import "../../../node_modules/react-vis/dist/style.css";

import {
  Crosshair,
  DiscreteColorLegend,
  FlexibleWidthXYPlot,
  HorizontalGridLines,
  LineMarkSeries,
  LineSeries,
  VerticalBarSeries,
  XAxis,
  YAxis
} from "react-vis";

import CurrencySpan from "../../components/Currency/CurrencySpan";
import React from "react";
import Spinner from "../../elements/Spinner/Spinner";
import _ from "lodash-es";

class BiPolarBarChart extends React.Component {
  constructor(props) {
    super(props);
    // alert("alert");
    this.state = {
      previousYear: this.buildFromProps(props.previousYear),
      previousYearNegative: props.previousYearNegative
        ? this.buildFromProps(props.previousYearNegative)
        : null,
      currentYear: this.buildFromProps(props.currentYear),
      currentYearNegative: props.currentYearNegative
        ? this.buildFromProps(props.currentYearNegative)
        : null,

      crosshairValues: []
    };

    this.state.previousYearLines = {
      data: this.computePosNegSumArray(
        this.state.previousYear.data,
        this.props.previousYearNegative
          ? this.state.previousYearNegative.data
          : null
      )
    };
    this.state.currentYearLines = {
      data: this.computePosNegSumArray(
        this.state.currentYear.data,
        this.props.currentYearNegative
          ? this.state.currentYearNegative.data
          : null
      )
    };

    // console.log("BiPolarBarChart constructor", this.state);
  }

  computePosNegSumArray = (array1, array2) => {
    let summedData = [];

    array1.forEach((value, index) => {
      const t = {
        ...value,
        y: value.y + (array2 ? array2[index].y : 0)
      };
      summedData.push(t);
    });

    return summedData;
  };

  buildFromProps = values => {
    if (values)
      return {
        title: values.title.toString() || "",
        disabled: false,
        color: values && values.color,
        data: Object.keys(values.data).map(key => {
          return {
            x: key,
            y: values.data[key],
            y0: 0
          };
        })
      };
    return {};
  };

  componentDidUpdate(prevProps) {
    const b1 = !_.isEqual(prevProps.previousYear, this.props.previousYear);
    const b2 = !_.isEqual(prevProps.currentYear, this.props.currentYear);

    let newState = {};
    if (b1) {
      newState.previousYear = this.buildFromProps(this.props.previousYear);
      newState.previousYearNegative = this.buildFromProps(
        this.props.previousYearNegative
      );

      newState.previousYearLines = {
        data: this.computePosNegSumArray(
          newState.previousYear.data,
          this.props.previousYearNegative
            ? newState.previousYearNegative.data
            : null
        )
      };
    }

    if (b2) {
      newState.currentYear = this.buildFromProps(this.props.currentYear);
      newState.currentYearNegative = this.buildFromProps(
        this.props.currentYearNegative
      );
      newState.currentYearLines = {
        data: this.computePosNegSumArray(
          newState.currentYear.data,
          this.props.currentYearNegative
            ? newState.currentYearNegative.data
            : null
        )
      };
    }

    if (b1 || b2) {
      // console.log("updated!!", this.state, this.props, newState);
      this.setState(newState);
    }
  }

  // const differenceSerie = withState(
  //   "differenceSerie",
  //   "setDifferenceSerie",
  //   ({ positiveData, negativeData }) => {
  //     return {
  //       title: "Rentabilité",
  //       disabled: false,
  //       color: "#447DF7",
  //       data: Object.keys(positiveData.data).map(key => {
  //         return { x: key, y: positiveData.data[key] + negativeData.data[key] };
  //       })
  //     };
  //   }
  // );

  legendClickHandler = (item, i) => {
    console.log("item, i", item, i);
    item["disabled"] = !item.disabled;
    switch (i) {
      case 0:
        return this.setState({ item });
      case 1:
        return this.setState({ item });

      default:
        return;
    }
  };

  nearestXHandler = (value, { index }) => {
    const crosshair = {
      crosshairValues: [
        {
          title: this.props.previousYear.title,
          x: value.x,
          y: this.state.previousYear.data[index].y,
          index
        },
        {
          title: this.props.currentYear.title,
          x: value.x,
          y: this.state.currentYear.data[index].y,
          index
        }
      ]
    };

    if (this.state.previousYearNegative)
      crosshair.crosshairValues[0].y += this.state.previousYearNegative.data[
        index
      ].y;
    if (this.state.currentYearNegative)
      crosshair.crosshairValues[1].y += this.state.currentYearNegative.data[
        index
      ].y;

    // console.log("crosshair", crosshair);
    this.setState(crosshair);
  };

  onMouseLeave = values => {
    this.setState({
      crosshairValues: []
    });
  };

  formatCrosshairTitle = values => {
    return {
      title: this.props.intl.formatMessage({ id: "ids_period" }),
      value: values[0].x
    };
  };

  formatCrosshairItems = values => {
    const currencyId =
      (this.props.companyDefaultInfos &&
        this.props.companyDefaultInfos.company &&
        this.props.companyDefaultInfos.company.currency &&
        this.props.companyDefaultInfos.company.currency.id) ||
      null;

    let ret = values.map((v, i) => {
      return {
        title: v.title,
        value: currencyId ? (
          <CurrencySpan currencyId={currencyId} value={_.round(v.y, 2)} />
        ) : (
          _.round(v.y, 2)
        )
      };
    });

    const ecart = {
      title: this.props.intl.formatMessage({ id: "ids_variation" }),
      value: currencyId ? (
        <CurrencySpan
          currencyId={currencyId}
          value={_.round(values[1].y - values[0].y, 2)}
        />
      ) : (
        _.round(values[1].y - values[0].y, 2)
      )
    };
    ret.push(ecart);

    return ret;
  };

  render() {
    // console.log("chart render", this);

    if (this.props.companyDefaultInfos.loading) {
      return <Spinner size="lg" fullScreen />;
    }

    return (
      <div>
        <DiscreteColorLegend
          onItemClick={this.legendClickHandler}
          width={180}
          items={[this.state.previousYear, this.state.currentYear]} //, differenceSerie]}
        />
        <FlexibleWidthXYPlot
          margin={{
            left: 80,
            right: 20,
            top: 10,
            bottom: 30
          }}
          onMouseDown={() => {
            if (this !== undefined)
              this.props.onSelectedPeriod(this.state.crosshairValues[0]);
          }}
          xType="ordinal"
          stackBy="y"
          colorType="category"
          onMouseLeave={this.onMouseLeave}
          height={300}
        >
          <YAxis title="" />
          <XAxis title="" />
          <HorizontalGridLines />
          {
            <VerticalBarSeries
              cluster="previousYear"
              // stack
              data={this.state.previousYear.data}
              style={
                this.state.previousYear.disabled
                  ? { opacity: 0.2 }
                  : { opacity: 0.9 }
              }
              onNearestX={this.nearestXHandler}
              color={this.state.previousYear.color}
            />
          }
          {this.state.previousYearNegative && (
            <VerticalBarSeries
              cluster="previousYear"
              stack
              data={this.state.previousYearNegative.data}
              style={
                this.state.previousYear.disabled
                  ? { opacity: 0.2 }
                  : { opacity: 0.6 }
              }
              onNearestX={this.nearestXHandler}
              color={this.state.previousYearNegative.color}
            />
          )}
          {
            <VerticalBarSeries
              cluster="currentYear"
              // stack
              data={this.state.currentYear.data}
              style={
                this.state.currentYear.disabled
                  ? { opacity: 0.2 }
                  : { opacity: 0.9 }
              }
              color={this.state.currentYear.color}
            />
          }
          {this.state.currentYearNegative && (
            <VerticalBarSeries
              cluster="currentYear"
              stack
              data={this.state.currentYearNegative.data}
              style={
                this.state.currentYear.disabled
                  ? { opacity: 0.2 }
                  : { opacity: 0.6 }
              }
              color={this.state.currentYearNegative.color}
            />
          )}
          {this.props.displayLines &&
            this.state.currentYearLines &&
            this.state.currentYearLines.data && (
              <LineMarkSeries
                stack={false}
                curve={"curveMonotoneX"}
                data={this.state.currentYearLines.data}
                style={
                  this.state.currentYear.disabled
                    ? { opacity: 0.2 }
                    : { opacity: 0.8 }
                }
                color={this.state.currentYear.color}
              />
            )}
          {this.props.displayLines &&
            this.state.previousYearLines &&
            this.state.previousYearLines.data && (
              <LineMarkSeries
                stack={false}
                curve={"curveMonotoneX"}
                data={this.state.previousYearLines.data}
                style={
                  this.state.previousYear.disabled
                    ? { opacity: 0.2 }
                    : { opacity: 0.8 }
                }
                color={this.state.previousYear.color}
              />
            )}
          <Crosshair
            itemsFormat={e => this.formatCrosshairItems(e)}
            titleFormat={e => this.formatCrosshairTitle(e)}
            values={this.state.crosshairValues}
          />
        </FlexibleWidthXYPlot>
      </div>
    );
  }
}

export default BiPolarBarChart;
